// filepath: /src/sections/AboutUsSection.js
import React, { useEffect, useState } from 'react';
import './AboutUsSection.css';

const AboutUsSection = () => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsVisible(true);
        }
      },
      { threshold: 0.2 }
    );

    const section = document.getElementById('nosotros');
    if (section) {
      observer.observe(section);
    }

    return () => {
      if (section) {
        observer.unobserve(section);
      }
    };
  }, []);

  const features = [
    {
      icon: (
        <svg width="32" height="32" viewBox="0 0 32 32" fill="none">
          <path d="M16 2C8.3 2 2 8.3 2 16s6.3 14 14 14 14-6.3 14-14S23.7 2 16 2zM24 17h-7v7h-2v-7H8v-2h7V8h2v7h7v2z" fill="currentColor" />
        </svg>
      ),
      title: "IA Avanzada",
      description: "Diagnósticos asistidos por inteligencia artificial que optimizan la precisión médica."
    },
    {
      icon: (
        <svg width="32" height="32" viewBox="0 0 32 32" fill="none">
          <path d="M28 6H4a2 2 0 00-2 2v16a2 2 0 002 2h24a2 2 0 002-2V8a2 2 0 00-2-2zM4 8h24v4.5l-4-3-8 6-8-6-4 3V8zm0 16V14.5l4-3 8 6 8-6 4 3V24H4z" fill="currentColor" />
        </svg>
      ),
      title: "Comunicación Fluida",
      description: "Integración con WhatsApp y herramientas de comunicación instantánea."
    },
    {
      icon: (
        <svg width="32" height="32" viewBox="0 0 32 32" fill="none">
          <path d="M16 2L4 8v10c0 7.5 5.2 14.3 12 16 6.8-1.7 12-8.5 12-16V8L16 2zm0 4.2L24 10v8c0 5.7-3.9 10.7-8 12-4.1-1.3-8-6.3-8-12v-8l8-3.8z" fill="currentColor" />
        </svg>
      ),
      title: "Seguridad Total",
      description: "Protección avanzada de datos médicos con cumplimiento HIPAA y ISO 27001."
    }
  ];

  return (
    <section id="nosotros" className={`about-us-section ${isVisible ? 'visible' : ''}`}>
      <div className="about-background">
        <div className="about-orb orb-1"></div>
        <div className="about-orb orb-2"></div>
      </div>

      <div className="container">
        <div className="about-header">
          <div className="section-badge animate-slide-up">
            <span className="badge-icon">
              <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
                <path d="M8 2v12M2 8h12" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
              </svg>
            </span>
            Conoce Think Health
          </div>
          <h2 className="section-title animate-slide-up">
            Revolucionando la
            <span className="gradient-text"> Atención Médica</span>
          </h2>
          <p className="section-subtitle animate-slide-up">
            Fusionamos inteligencia artificial con práctica clínica para ofrecer
            una experiencia médica integral, personalizada y sin precedentes.
          </p>
        </div>

        <div className="about-content">
          <div className="about-story glass-card animate-slide-left">
            <div className="story-header">
              <div className="story-icon">
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
                  <path d="M12 2L2 7v10c0 5.55 3.84 10.74 9 12 5.16-1.26 9-6.45 9-12V7l-10-5z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                </svg>
              </div>
              <h3>Nuestra Historia</h3>
            </div>
            {/* <p>
              En ThinkHealth, redefinimos la interacción médica fusionando IA con práctica clínica. 
              Nuestra plataforma integral está diseñada para pacientes y profesionales, ofreciendo 
              consultas virtuales, diagnósticos asistidos y seguimiento personalizado.
            </p>
            <p>
              Capturamos datos vitales como presión arterial, peso y altura, optimizando el flujo 
              de trabajo médico y la experiencia del paciente con tecnología de vanguardia.
            </p> */}
            <p>
              <span className='greenlight'>ThinkHealth</span> nace en 2019 de la visión del <span className='highlight'>Dr. Sergio Emmanuel Delgado Félix</span>, médico cirujano comprometido con mejorar la eficiencia clínica mediante tecnología. Al vivir de primera mano los retos de la documentación médica, decidió crear una plataforma de inteligencia artificial que optimizara la nota médica, facilitara el diagnóstico asistido y liberara tiempo valioso para el paciente.
            </p>

            <p>
              Ese mismo año, presentó públicamente ThinkHealth en la Convención Nacional CANIETI, marcando el inicio de una nueva etapa en la salud digital mexicana. Desde entonces, la plataforma ha sido adoptada por cientos de médicos en proyectos como el Protocolo Camelia y ha participado en foros internacionales como el Congreso Colombiano de Radiología.
            </p>

            <p>
              Bajo el liderazgo del Dr. Delgado Félix, ThinkHealth se consolida como una solución pionera que integra reconocimiento de voz, automatización clínica y seguimiento personalizado, transformando la práctica médica en México y Latinoamérica.
            </p>
          </div>


          <div className="about-partnership glass-card animate-slide-right">
            <div className="partnership-header">
              <div className="partnership-logo">
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
                  <path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                </svg>
              </div>
              {/* <h3>Colaboración con Grehta.org</h3> */}
              <h3>Colaboración con </h3>
            </div>
            {/* <p>
              En alianza estratégica con <span className="highlight">Grehta.org</span>,
              referente en cardiología, extendemos nuestro compromiso hacia la prevención
              y manejo especializado de hipertensión y afecciones cardiovasculares.
            </p> */}

            <p>
              En alianza con <span className="redlight">Grehta.org</span>, referente nacional en cardiología, participamos en el <strong>Protocolo Camelia</strong>, una iniciativa clínica donde más de 200 médicos integraron nuestra plataforma para el manejo especializado de hipertensión y enfermedades cardiovasculares.
            </p>
            <div className="partnership-badge">
              <span className="badge-text">Expertos en Cardiología</span>
            </div>
            <p></p>
            <p>
              En <strong>2019</strong>, presentamos oficialmente ThinkHealth en la <span className="highlight">Convención Nacional CANIETI</span>, marcando el inicio de nuestra misión de modernizar la atención médica mediante inteligencia artificial, diagnóstico asistido y automatización de la nota médica.
            </p>

            <p>
              Además, nuestra tecnología ha sido destacada en foros internacionales como el <strong>Congreso Colombiano de Radiología</strong>, impulsando el uso del dictado médico por voz y la documentación clínica digital en Latinoamérica.
            </p>
            
          </div>
        </div>

        <div className="about-features">
          <h3 className="features-title animate-slide-up">
            Características Principales
          </h3>
          {/* <div className="features-grid">
            {features.map((feature, index) => (
              <div 
                key={index} 
                className={`feature-card glass-card animate-slide-up`}
                style={{ animationDelay: `${0.1 + index * 0.1}s` }}
              >
                <div className="feature-icon">
                  {feature.icon}
                </div>
                <h4 className="feature-title">{feature.title}</h4>
                <p className="feature-description">{feature.description}</p>
              </div>
            ))}
          </div> */}
        </div>

        <div className="mission-vision">
          <div className="mission glass-card animate-slide-left">
            <div className="mv-header">
              <div className="mv-icon">
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
                  <path d="M12 2L2 7v10c0 5.55 3.84 10.74 9 12 5.16-1.26 9-6.45 9-12V7l-10-5z" stroke="currentColor" strokeWidth="2" />
                </svg>
              </div>
              <h3>Nuestra Misión</h3>
            </div>
            <p>
              Desarrollar soluciones médicas impulsadas por inteligencia artificial que optimicen la práctica clínica,
              agilicen la elaboración de notas médicas y fortalezcan la precisión diagnóstica,
              mejorando la eficiencia del sistema de salud y elevando la calidad de atención para médicos y pacientes.
            </p>
          </div>

          <div className="vision glass-card animate-slide-right">
            <div className="mv-header">
              <div className="mv-icon">
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
                  <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z" stroke="currentColor" strokeWidth="2" />
                  <circle cx="12" cy="12" r="3" stroke="currentColor" strokeWidth="2" />
                </svg>
              </div>
              <h3>Nuestra Visión</h3>
            </div>
            <p>
              Ser la plataforma líder en Latinoamérica en transformación digital del sector salud,
              reconocida por empoderar a los profesionales médicos mediante tecnologías inteligentes que hacen la consulta más humana,
              rápida y efectiva.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default AboutUsSection;
